module.exports = __webpack_public_path__ + "static/media/jimmy-boite-sante.d88ebb9e.png";